module.exports = __webpack_public_path__ + "static/img/platphom9.fa658f8a.png";